import { EventEmitterService } from '@core/services/event-emitter.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthHttpService } from '@core/services/auth-http.service';
import * as fromAuthActions from '@core/store/auth/auth.actions';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/store/reducers';
import { tap, delay } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit {

  @ViewChildren('focusInput') focusInput: QueryList<ElementRef>;
  @ViewChildren('passwordField') passwordField: QueryList<ElementRef>;
  messages$ = this.auth.messages$;
  isSuccess = this.auth.isSuccess;
  form: FormGroup;
  passwordInput = {
    isMasked: true,
    type: null,
    icon: null,
    isValidPassword: true
  };

  constructor(
    public dialogRef: MatDialogRef<LoginModalComponent>,
    private router: Router,
    private auth: AuthHttpService,
    private store: Store<AppState>,
    private fb: FormBuilder,
    public loadingBar: LoadingBarService,
    private eventEmitterService: EventEmitterService
  ) { }

  ngOnInit() {
    this.onPasswordMask();
    this.initializeForm();
    of(null).pipe(
        delay(200), tap(() => this.focusInput.first.nativeElement.focus()
    )).subscribe();
    this.eventEmitterService.selectInputEmitter.subscribe((name: any) => {
      this.onSelectAll();
    });
  }

  onPasswordMask() {
    this.passwordInput.isMasked = !this.passwordInput.isMasked;
    this.passwordInput.type = this.passwordInput.isMasked ? 'text' : 'password';
    this.passwordInput.icon = this.passwordInput.isMasked ? 'icon-eye' : 'icon-eye-slash';
  }

  onCloseDialog(event?: Event ) {
    this.dialogRef.close();
  }

  submit() {
    sessionStorage.setItem('initialLogin', '1');
    this.loadingBar.start();
    const { username, password } = this.form.value;

    this.auth.login(username, password).pipe(
      tap( (res) => {
        this.store.dispatch(fromAuthActions.login( {
          user: res.data.user,
          token: res.data.token,
        }));
        localStorage.setItem('verified_number', res.data.user.phone_validated);
        this.onCloseDialog();
        if (res.data.user.name === '' && res.data.user.email === ''){
          this.router.navigate(['/member/profile']);
        } else {
          localStorage.setItem('profile', res.data.user.name);
          this.router.navigate(['/member/']);
        }
        this.loadingBar.complete();
      })
    ).subscribe(() => this.isSuccess = this.auth.isSuccess);
  }

  toLowerCaseInput(controlName: string, event: Event) {
    this.auth.forceLowerCaseInputControl(this.form, controlName, event);
  }

  private onSelectAll(){
    this.passwordField.first.nativeElement.select();
  }

  private initializeForm() {
    this.form = this.fb.group({
      username: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(320)
        ])
      ],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(100)
        ])
      ]
    });
  }

}
